import { useEffect, useRef, useState } from "react";
import { cx } from "../../../Util/classHelpers";
import styles from "./GenericModal.module.css";

const ANIMATION_DURATION = 300;

const GenericModal = ({ open, onClose, backdropClassName, modalClassName, children }) => {
  const modalRef = useRef(null);
  const [shouldRender, setShouldRender] = useState(open);
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setExiting(false);
    } else if (shouldRender) {
      setExiting(true);
      const timeout = setTimeout(() => {
        setShouldRender(false);
        setExiting(false);
      }, ANIMATION_DURATION);
      return () => clearTimeout(timeout);
    }
  }, [open, shouldRender]);

  useEffect(() => {
    if (!shouldRender) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose?.();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [shouldRender, onClose]);

  useEffect(() => {
    if (!shouldRender) return;
    const handleClick = (e) => {
      if (modalRef.current && e.target === modalRef.current) {
        onClose?.();
      }
    };
    const node = modalRef.current;
    node?.addEventListener("mousedown", handleClick);
    return () => node?.removeEventListener("mousedown", handleClick);
  }, [shouldRender, onClose]);

  if (!shouldRender) return null;

  return (
    <div
      className={cx(
        styles.modalBackdrop,
        backdropClassName,
        shouldRender && styles.show,
        exiting && styles.exit
      )}
      ref={modalRef}
      tabIndex={-1}
      aria-modal="true"
      role="dialog"
    >
      <div className={cx(styles.modalDialog, exiting && styles.dialogExit, modalClassName)}>
        {children}
      </div>
    </div>
  );
};

export default GenericModal;
